import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthProvider";
import '../App.css';
const LoginElements = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [alert, setAlert] = useState('');
    const handleLogin = (e) => {
        e.preventDefault();
        // Perform your authentication logic here
        // For example, if using an API call:
        // try {
        //   const response = await fetch('/api/login', {
        //     method: 'POST',
        //     body: JSON.stringify({ username, password }),
        //     headers: { 'Content-Type': 'application/json' },
        //   });
        //   const data = await response.json();
        //   if (data.success) {
        //     setIsAuthenticated(true); // Or update your authentication context
        //     navigate('/'); // Redirect to the protected route (e.g., home page)
        //   } else {
        //     // Handle login failure
        //   }
        // } catch (error) {
        //   // Handle error
        // }

        // For a basic example:
        //Replace with access token from API response
        if (username === 'admin' && password === 'admin') {
            localStorage.setItem('accessToken', 'your-access-token');
            login(); // Set isAuthenticated to true upon successful login
            navigate('/dashboard'); // Redirect to the protected route (e.g., home page)
        } else {
            setAlert('Invalid username or password');
        }
    }
    return (
        <div className="loginElementsMainDiv">
            <h1>Login</h1>
            <div className="loginElementsUserName">
                <label htmlFor="username">Username </label>
                <input type="text" id="username" name="username" onChange={(e) => setUsername(e.target.value)} />
            </div>
            <div className="loginElementsPassword">
                <label htmlFor="password">Password </label>
                <input type="password" id="password" name="password" onChange={(e) => setPassword(e.target.value)} />
            </div>
            <button onClick={handleLogin} className='loginElementsButton'>Log In</button>
            {alert && <p className="alert">{alert}</p>}
        </div>
    )
}
const LogOutElements = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const HandleLogout = () => {
        // Clear any stored authentication data (e.g., in localStorage)
        localStorage.removeItem('accessToken');
        logout(); // Set isAuthenticated to false
        // navigate('/login'); // Redirect to the login page after logout
        navigate('/');
    };
    return (
        <div className="logoutElementsMainDiv">
            <h1>Logout</h1>
            <button onClick={HandleLogout}>Log Out</button>
            <button onClick={() => navigate('/')}>Go to main page</button>
            <button onClick={() => navigate('/dashboard')}>Go to dashboard</button>
        </div>)
}
function Login() {
    const { checkAuth } = useAuth();
    return (
        <div className="loginMainDiv">
            {
                checkAuth() ? <LogOutElements /> : <LoginElements />
            }

        </div >)
}
export { Login, LogOutElements, LoginElements };